import React from 'react';
import './HeroBanner.css';

const HeroBanner = () => {
  return (
    <section className="hero-banner">
      <img
        src="/images/homepageHero.jpg"
        alt="Cadillac 2024 All-Electric Lyric - Nothing Like A Cadillac"
        className="hero-image"
      />
    </section>
  );
};

export default HeroBanner;
